module.exports = __webpack_public_path__ + "img/hw-b1.ad1fbedc.png";